import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { usePopoverPortalContext } from "./PopoverPortalContext";

interface ColorPickerFormProps {
  colors: string[];
  onChange: (input: string) => void;
  pickerColorsTestId?: string;
  subtitle: string;
  value: string;
}

export const ColorPickerForm = ({
  subtitle,
  value,
  colors,
  onChange,
  pickerColorsTestId,
}: ColorPickerFormProps) => {
  const [selectedColor, setSelectedColor] = useState(value);
  const { onClose } = usePopoverPortalContext();

  const onApply = () => {
    onChange(selectedColor);
    onClose();
  };

  return (
    <>
      <div
        className="flex w-full flex-col gap-y-3 px-4"
        data-testid="color-picker-form"
      >
        <Typography.LabelXs color="text-default">{subtitle}</Typography.LabelXs>
        <div
          className="grid grid-cols-6 gap-2"
          data-testid={pickerColorsTestId}
        >
          {colors.map((color: string) => (
            <button
              key={color}
              type="button"
              className={classNames("size-8 rounded-md border", {
                "border-darkest border-2": selectedColor === color,
              })}
              style={{ backgroundColor: color }}
              onClick={() => setSelectedColor(color)}
            />
          ))}
        </div>
      </div>
      <div
        className="flex w-full flex-row justify-between px-4 pt-3"
        data-testid="color-picker-form-footer"
      >
        <Typography.LabelSm color="text-lightest">
          {selectedColor}
        </Typography.LabelSm>
        <Button type="button" onClick={onApply} variant="circle">
          {t("save")}
        </Button>
      </div>
    </>
  );
};
